export const environment = {
    recaptchaKey: "6LcX_i4sAAAAABQqIpPwjA1toVNeMxm3j3ztv0u2",
    baseUrl: "/api/cryp/",
    defaultDecimalDigits: 2,
    environmentName: "development",
    localCaptchaBypassToken: "",
    analytics: {
        enabled: true,
        measurementId: "G-BM0MVC6RCL",
        debug: true
    }
};
